import { HELP_CENTER_LABEL } from '../../../screens/help-center/utils';
import {
  POP_FROM_HISTORY,
  SET_CURRENT_LEVEL_ITEMS,
  SET_HC_LEVEL_HISTORY,
  SET_HELP_CENTER_LABELS,
  SET_HELP_CENTER_SELECTED_TRANSACTION,
  RAISE_NEW_ENQUIRY,
  SET_CONFIGURATION_DATA,
  SET_CURRENT_HELP_CENTRE_TICKETS,
  OPEN_EXISTING_CONVERSATION,
  RETURN_FROM_RAISE_ENQUIRY,
  SET_ACTIVE_CHAT_WEB_WIDGET,
  SET_IS_REVAMP_API_CALLED,
  HELP_CENTER_UI_LOADING,
  RESET_HELP_CENTER_LEVELS,
  TOGGLE_NEW_TRANSACTION_CHAT,
  SET_ACTIVE_CHAT_INFO,
  SET_PUBLIC_PAGE_LEVEL_VALUE,
  TOGGLE_IS_NAVIGATED_FROM_DEEPLINK
} from '../../action-contants';

const INITIAL_STATE = {
  currentLevelItems: {},
  levelHistory: [],
  isNewUIEnabled: true,
  helpCenterLabels: HELP_CENTER_LABEL,
  selectedTransaction: {},
  raiseNewEnquiryFlag: false,
  configurationData: {},
  currentHelpCentreTickets: [],
  openExistingTicketConversation: false,
  isReturnFromEnquiry: false,
  isZenDeskActiveChat: false,
  isRevampApiCalled: false,
  isHelpCenterUiLoading: false,
  helpCenterResetFlag: false,
  isNewTransactionChatCreated: false,
  activeChatInfo: {},
  publicPageLevelValue: '',
  isNavigatedFromDeepLink: false
};

export default function helpCenterReducer(
  state = INITIAL_STATE,
  action: { type: string; data: any }
): any {
  switch (action.type) {
    case SET_CURRENT_LEVEL_ITEMS: {
      return {
        ...state,
        currentLevelItems: action.data
      };
    }

    case SET_CONFIGURATION_DATA: {
      return {
        ...state,
        configurationData: action.data
      };
    }
    case SET_HC_LEVEL_HISTORY: {
      const newData = [...state.levelHistory, action.data];
      return {
        ...state,
        levelHistory: newData
      };
    }

    case POP_FROM_HISTORY: {
      return {
        ...state,
        levelHistory: action.data
      };
    }

    case SET_HELP_CENTER_LABELS: {
      return {
        ...state,
        helpCenterLabels: action.data
      };
    }
    case SET_CURRENT_HELP_CENTRE_TICKETS: {
      return {
        ...state,
        currentHelpCentreTickets: action.data
      };
    }
    case SET_HELP_CENTER_SELECTED_TRANSACTION: {
      return {
        ...state,
        selectedTransaction: action.data
      };
    }
    case RAISE_NEW_ENQUIRY: {
      return {
        ...state,
        raiseNewEnquiryFlag: action.data
      };
    }
    case OPEN_EXISTING_CONVERSATION: {
      return {
        ...state,
        openExistingTicketConversation: action.data
      };
    }
    case RETURN_FROM_RAISE_ENQUIRY: {
      return {
        ...state,
        isReturnFromEnquiry: action.data
      };
    }

    case SET_ACTIVE_CHAT_WEB_WIDGET: {
      return {
        ...state,
        isZenDeskActiveChat: action.data
      };
    }
    case SET_IS_REVAMP_API_CALLED: {
      return {
        ...state,
        isRevampApiCalled: action.data
      };
    }

    case HELP_CENTER_UI_LOADING: {
      return {
        ...state,
        isHelpCenterUiLoading: action.data
      };
    }

    case RESET_HELP_CENTER_LEVELS:
      return {
        ...state,
        currentLevelItems: INITIAL_STATE.currentLevelItems,
        levelHistory: INITIAL_STATE.levelHistory,
        helpCenterResetFlag: action.data,
        isNavigatedFromDeepLink: false
      };
    case TOGGLE_NEW_TRANSACTION_CHAT: {
      return {
        ...state,
        isNewTransactionChatCreated: action.data
      };
    }

    case SET_ACTIVE_CHAT_INFO: {
      return {
        ...state,
        activeChatInfo: action.data
      };
    }
    case SET_PUBLIC_PAGE_LEVEL_VALUE: {
      return {
        ...state,
        publicPageLevelValue: action.data
      };
    }
    case TOGGLE_IS_NAVIGATED_FROM_DEEPLINK: {
      return {
        ...state,
        isNavigatedFromDeepLink: action.data
      };
    }

    default:
      return state;
  }
}
